<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Manage User</h2>
            </div>
        </div>
        <a-card class="mb-4">
            <h5 class="mb-3">Filter by</h5>
            <a-form :form="form"  @submit="searchHandel">
                <div class="row">
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-input size="large"
                                v-decorator="['name', { rules: [{ required: false }] }]"
                                placeholder="Search by name"
                            />
                        </a-form-item>
                    </div>
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-select size="large"
                                v-decorator="[ 'status',
                                    { rules: [{ required: false}] },
                                ]"
                                placeholder="Search by status"
                            >
                                <a-select-option value="1">
                                    Active
                                </a-select-option>
                                <a-select-option value="0">
                                    Inactive
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>

                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-select size="large"
                                show-search
                                :filter-option="filterOption"
                                v-decorator="['role', { 
                                    rules: [{ required: false }], }]"
                                placeholder="Search by role" style="width: 100%">
                                <template v-for="role in roles" >
                                    <a-select-option :key="role.id" :value="role.name">
                                        {{role.name}}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                    </div>

                    <div class="col-md-12">
                        <a-button class="px-5" type="danger" size="large" @click="exportReport">
                            Export
                        </a-button>
                        <span class="float-right">
                            <a-button type="primary" class="btn btn-secondary rounded font-md mr-2" size="large" @click="resetFilter">
                                Reset
                            </a-button>
                            <a-button type="primary" class="btn btn-xs rounded font-md" size="large" html-type="submit">
                                Filter
                            </a-button>
                        </span>
                    </div> 
                </div>
            </a-form>
        </a-card>
        
        <a-card >
            <a-table
                :columns="columns"
                :data-source="users"
                :pagination="{ 
                    current: currentPage,
                    total: pageCount * 10,
                    onChange: (page) => paginate(page),
                 }"
                :scroll="{x: 'calc(700px + 50%)', y: 900 }"
            > <!-- x: 'calc(600px + 50%)', -->
            
            <span slot="name" slot-scope="text, record">
                <img v-if="record.image_path" class="img-xs rounded-circle" :src="record.image_path" alt="User">
                {{record.name}}
            </span>

            <span slot="status" slot-scope="text, record">
                {{record.status ? 'Active' : 'Inactive'}}
            </span>

            <span slot="action" slot-scope="text, record"> <!-- slot-scope="text, record" -->
                <a-button class="btn btn-xs" size="small" type="primary">
                    <router-link :to="'/edit-user/'+record.id" >
                        Edit
                    </router-link>
                </a-button>
                <a-button v-if="canView('can_reset_password')"  class="btn btn-xs ml-2" size="small" @click="resetPassword(record)">
                    Reset Password
                </a-button>
            </span>
            </a-table>
        </a-card>

        <a-modal
            title="Reset Password"
            :visible="showChangePassword"
            @cancel="() => { this.showChangePassword = false; this.selectedUser = null; form.resetFields() }"
            :footer="null"
            >
            <a-form :form="form" layout='vertical' @submit="changePassword">
                <a-form-item label="New Password">
                    <a-input size="large"
                        v-decorator="[
                        'new_password',
                        { rules: [{ required: true, message: 'Please input your Password!' }] },
                        ]"
                        type="password"
                        placeholder="New Password"
                    >
                        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-item>

                <a-form-item label="Confirm Password">
                    <a-input size="large"
                        v-decorator="[
                        'confirm_password',
                        { rules: [{ required: true, message: 'Please input your Password!' }] },
                        ]"
                        type="password"
                        placeholder="Confirm Password"
                    >
                        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-item>

                <a-form-item>
                    <a-button @click="() => {this.showChangePassword = false; form.resetFields()}" size="large">
                        Cancel
                    </a-button>
                    <a-button type="primary" :loading="loading" size="large" class="float-right" html-type="submit">
                        Submit
                    </a-button>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>


<script>
    import { USER_LIST, GET_ROLES, RESET_USER_PASSOWRD, USER_LIST_EXPORT } from "../../../script/api";
    import { getData, postData } from "../../../script/api-service";
    import {buildSearchQuery, checkUserPermission, alertPop} from "../../../script/helper";

    const columns = [
        {
            title: 'Name',
            // dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
        },
        {
            title: 'Mobile',
            dataIndex: 'mobile',
        },
        {
            title: 'Role',
            dataIndex: 'roles[0].name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            title: 'Address',
            dataIndex: 'address',
        },
        {
            title: 'Status',
            key: 'status',
            scopedSlots: { customRender: 'status' },
        },
        {
            title: 'Action',
            key: 'action',
            width: 290,
            fixed: "right",
            scopedSlots: { customRender: 'action' },
        }
    ];

export default {
    data() {
        return {
            columns,
            users: [],
            search: null,
            form: this.$form.createForm(this, { name: 'searchDivision' }),
            currentPage: 1, 
            pageCount: 0,
            roles: [],
            showChangePassword: false,
            selectedUser: null,
            loading: false
        };
    },
    watch: {
        search: function (newVal, oldVal) {
            if (newVal || (!newVal && oldVal)) {
                this.getUserList(newVal);
            }
        },
    },
    methods: {
        async getRoles() {
            let res = await getData(GET_ROLES);

            if (res) {
                let masterData = res.data?.data;
                this.roles = masterData || [];
            }
        },
        async getUserList(query) {
            let url = USER_LIST + '?';

            if (query) url = url + query;
            if (this.currentPage) url = url + `&page=${this.currentPage}`;

            let res = await getData(url);

            if (res) {
                let masterData = res.data?.data;
                this.users = masterData.data;
                this.pageCount = masterData.paginator.total_pages;
            }
        },
        searchHandel(e) {
            e.preventDefault();
            this.form.validateFields( async(err, values) => {
                if (!err) {
                    this.search = buildSearchQuery(values);
                    this.currentPage = 1;
                }
            })
        },
        resetFilter() {
            this.form.resetFields();
            this.search = '';
            this.currentPage = 1;
        },
        paginate(page) {
            this.currentPage = page;
            this.getUserList(this.search);
        },
        canView(allow) {
            return checkUserPermission(allow);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        resetPassword(data) {
            this.showChangePassword = true;
            this.selectedUser = data;
        },
        changePassword(e) {
            e.preventDefault();
            
            this.form.validateFields(async (err, values) => {
                if (!err) {
                    this.loading = true;

                    let res = await postData(RESET_USER_PASSOWRD, {
                        new_password: values.new_password,
                        confirm_password: values.confirm_password,
                        user_id: this.selectedUser.id
                    });

                    if (res) {
                        this.form.resetFields();
                        this.showChangePassword = false,
                        this.selectedUser = null,
                        this.loading = false;
                        alertPop('success', "Password reset successfully!")
                    } else {
                        this.loading = false;
                        
                        // alertPop('error', "Something went worng!")
                    }
                }
            });
        },
        exportReport() {
            let str = buildSearchQuery(this.form.getFieldsValue());

            let url = USER_LIST_EXPORT + '?';
            if (str) url = url + str;
            let api_link = process.env.VUE_APP_BASEURL;
            
            let baseURL = api_link + url;
            window.open(baseURL, '_blank');
        }
    },
    mounted() {
        this.getUserList();
        
        this.getRoles();
        if (!checkUserPermission('update_user')) {
            this.columns.pop();
        }
    },
};
</script>